const faqStyle = {
  page: {},
  section: {
    marginBottom: 30,
    "&:last-child": {
      marginBottom: 0
    }
  },
  sectionTitle: {
    marginTop: 0,
    marginBottom: 16,
    fontSize: 26,
    lineHeight: 1.25
  },
  sectionIntro: {
    marginBottom: 20,
    lineHeight: 1.6
  },
  questionCard: {
    marginBottom: 20,
    "&:last-child": {
      marginBottom: 0
    }
  },
  contactSection: {
    marginTop: 30
  },
  contactSectionTitle: {
    marginTop: 0,
    marginBottom: 14,
    fontSize: 26,
    lineHeight: 1.25
  },
  contactCard: {
    width: "100%"
  },
  contactCardBody: {
    padding: "28px 24px !important"
  },
  contactIntro: {
    marginBottom: 22,
    paddingBottom: 18,
    borderBottom: "1px solid #ececec",
    textAlign: "center"
  },
  contactLine: {
    fontSize: 18,
    lineHeight: 1.45,
    marginTop: 0,
    marginBottom: 6
  },
  contactSubline: {
    fontSize: 15,
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 0,
    color: "#6c757d"
  },
  contactItems: {
    display: "flex",
    flexWrap: "wrap",
    gap: 16
  },
  contactItem: {
    flex: "1 1 240px",
    display: "flex",
    alignItems: "flex-start",
    padding: "14px 16px",
    borderRadius: 6,
    background: "#f8fafb",
    border: "1px solid #eef1f4"
  },
  contactIconWrap: {
    width: 42,
    height: 42,
    minWidth: 42,
    borderRadius: "50%",
    background: "#eef7fb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 14
  },
  contactIcon: {
    color: "#00acc1",
    fontSize: 20
  },
  contactItemBody: {
    minWidth: 0
  },
  contactItemLabel: {
    fontSize: 13,
    lineHeight: 1.4,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "#6c757d",
    marginTop: 0,
    marginBottom: 4
  },
  contactDetail: {
    fontSize: 15,
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 0
  },
  questionCardBody: {
    paddingTop: "8px !important",
    paddingBottom: "8px !important"
  },
  accordionPanel: {
    borderBottom: "none !important",
    boxShadow: "none !important"
  },
  accordionSummary: {
    borderBottom: "none !important",
    "& h4": {
      fontSize: "16px !important",
      lineHeight: "1.35 !important",
      fontWeight: "400 !important"
    },
    "&.Mui-expanded h4": {
      fontWeight: "700 !important"
    }
  },
  answerContent: {
    width: "100%",
    lineHeight: 1.6,
    paddingBottom: 8
  },
  markdownParagraph: {
    fontSize: 15,
    lineHeight: 1.7,
    marginTop: 0,
    marginBottom: 12
  },
  markdownStrong: {
    fontWeight: 700
  },
  markdownH1: {
    fontSize: 22,
    lineHeight: 1.3,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 14
  },
  markdownH2: {
    fontSize: 19,
    lineHeight: 1.35,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 12
  },
  markdownH3: {
    fontSize: 17,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 10
  },
  markdownH4: {
    fontSize: 16,
    lineHeight: 1.4,
    fontWeight: 700,
    marginTop: 0,
    marginBottom: 10
  },
  markdownList: {
    marginTop: 0,
    marginBottom: 12,
    paddingLeft: 22
  },
  markdownListItem: {
    fontSize: 15,
    lineHeight: 1.7,
    marginBottom: 6
  },
};

export default faqStyle;
